import React, {Component} from "react";
import PropTypes from "prop-types";

import {inject, observer} from 'mobx-react';
import {toJS} from "mobx";


// core components
import GridContainer from "../../components/Grid/GridContainer.jsx";
import ItemGrid from "../../components/Grid/ItemGrid.jsx";
import Button from "../../components/CustomButtons/Button.jsx";

import SweetAlert from "react-bootstrap-sweetalert";

import Select from "material-ui/Select/Select";
import MenuItem from "material-ui/Menu/MenuItem";

// creates a beautiful scrollbar
import {withStyles} from "material-ui";
import appStyle from "../../assets/jss/material-dashboard-pro-react/layouts/dashboardStyle.jsx";
import '../../assets/css/dashboard.css';


import Cookies from "universal-cookie";


const cookies = new Cookies();


@inject('store')
@observer
class HomeCalendar extends Component {

    constructor(props) {
        super(props);
        this.state = {
            calendar_data: [],
            error_calendar_data: false,
            calendars_data_exists: true
        };
        this.store = this.props.store.appState;
    }


    componentDidMount() {
        this.getCalendars();
        this.store.clearCalendarData();
    }



    goToCreateNewCalendar = () => {
        let self = this;
        self.props.history.push({
            pathname: '/calendar-configuration'
        });
    }

    selectCalendar = (event) => {
        let self = this;
        const idCalendar = event.target.value;
        const project_id = cookies.get('project_id');
        const data = {idProject: project_id, idCalendar: idCalendar};

        self.store.getCalendarByProjectIdCalendarId(data, function (res) {
            if (res) {
                const calendar = res[0];
                self.store.calendar_selected = true;
                self.store.selected_calendar_id = calendar.id;
                self.store.selected_calendar_name = calendar.name;
                self.store.selected_calendar_url = calendar.url;
                self.store.lang = calendar.lang;
                self.props.history.push('/calendar-configuration');
            }
        });
    }

    getCalendars = () => {
        const self = this;
        const project_id = cookies.get('project_id');
        const data = {idProject: project_id};
        self.store.getCalendars(data, function (res) {
            if (res && res.length > 0) {
                self.setState({calendar_data: res});
            } else {
                self.setState({
                    calendars_data_exists: false
                })
            }
        });
    }


    render() {
        // const {classes, ...rest} = this.props;
        const {classes} = this.props;
        const project_id = cookies.get('project_id');
        const project_name = cookies.get('project_name');
        const DEFAULT_TEXT = toJS(this.store.DEFAULT_TEXT);
        const {calendar_data, error_calendar_data, calendars_data_exists} = this.state;

        return (
            <div>
                <GridContainer justify='center'>
                    <ItemGrid xs={10} sm={10} md={10}>
                        <h2 style={{textAlign: "center"}}>{project_id} - {project_name}</h2>
                    </ItemGrid>
                </GridContainer>

                <GridContainer justify='center' style={{alignItems: 'center'}}>
                    <ItemGrid xs={6} sm={6} md={6}>
                        <div id='select-calendar-button'>
                            <Button
                                style={{width: '218px', height: '2.5rem', float: 'right'}}
                                color='rose'
                                size='sm'
                                round
                                onClick={() => {
                                    this.goToCreateNewCalendar()
                                }}
                            ><p className='select_calendar'>{DEFAULT_TEXT.create_calendar.toUpperCase()}</p>
                            </Button>
                        </div>
                    </ItemGrid>

                    <ItemGrid xs={6} sm={6} md={6}>
                        <div id='select-calendar-button'>
                            <Button
                                style={{width: '218px', height: '2.5rem'}}
                                color={calendars_data_exists ? 'purple' : 'primary'}
                                size='sm'
                                round>
                                <Select
                                    displayEmpty
                                    disabled={!calendars_data_exists}
                                    renderValue={
                                        this.store.selected_calendar_id !== ''
                                            ? null
                                            : () => <p
                                                className={'select_calendar'}>{DEFAULT_TEXT.select_calendar.toUpperCase()}</p>
                                    }
                                    fullWidth={true}
                                    onChange={(event) => this.selectCalendar(event)}
                                    value={this.store.selected_calendar_id}
                                    style={{color: "white"}}
                                    disableUnderline={true}
                                    inputProps={{
                                        name: "simpleSelect",
                                        id: "calendar-select"
                                    }}>
                                    {
                                        calendar_data.map((calendar, key) => {
                                            return (
                                                <MenuItem key={key} value={calendar.id}>
                                                    <span className={'span-lang'}>{calendar.name}</span>
                                                </MenuItem>
                                            )
                                        })
                                    }
                                </Select>
                            </Button>
                        </div>
                    </ItemGrid>
                    {
                        error_calendar_data &&
                        <SweetAlert
                            warning
                            title=""
                            onConfirm={() => this.setState({error_calendar_data: false})}
                            confirmBtnCssClass={classes.button + " " + classes.success}
                            cancelBtnStyle={{backgroundColor: '#e52d27'}}
                            confirmBtnText='OK'
                        > {DEFAULT_TEXT.error_calendar_data}
                        </SweetAlert>
                    }
                </GridContainer>
            </div>
        );
    }
}

HomeCalendar.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(appStyle)(HomeCalendar);



// WEBPACK FOOTER //
// ./src/views/Home/HomeCalendar.jsx